<template>

  <footer class="footer">

    <div class="footer__container">

      <div class="footer__helper"></div>

      <div class="footer__contacts">

        <router-link class="footer__privacy" to="/privacy">Privacy policy</router-link>

        <div class="footer__address">
          &copy;&nbsp;2021 4MKTG For Marketing srl&nbsp;<br class="footer__break">
          P.I 03840620961&nbsp;&mdash; REA MB-1705666&nbsp;<br class="footer__break">
          Via Torri Bianche, 10&nbsp;&mdash; 20871&nbsp;<br class="footer__break">
          Vimercate (MB)
        </div>

      </div>

    </div>

    <a class="footer__made-in" href="//rutorika.com" target="_blank"></a>

  </footer>

</template>

<script>
  export default {
    name: 'TheFooter',
  };
</script>



// WEBPACK FOOTER //
// src/components/TheFooter.vue